const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJumpReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 2.41709733,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 37.000145,34.000005 V 30.169676 L 47.137293,37.830345 37.000145,45.491 V 41.660671 H 26.863 v -7.660666 z",
    id: "path3690"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.94838595
    },
    d: "M 3,31 H 13.421053 V 16.5 H 3 Z m 12.157895,0 H 36 V 16.5 H 15.157895 Z M 3,2 V 14.428572 H 36 V 2 Z",
    id: "path5096"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpReporting);
export default __webpack_public_path__ + "static/media/jump-reporting.964247c823f00e53b7696105be61856f.svg";
export { ForwardRef as ReactComponent };